import { createContext, useCallback, useContext, useState } from "react";
import { Alert } from "../components/Alert";
import { Confirm } from "../components/Confirm";
import Loader from "../components/Loader";
import { Toast, ToastContainer } from "react-bootstrap";
import { Variant } from "react-bootstrap/esm/types";

const UtilityContext = createContext<any>({});

export const UtilityProvider: React.FC<any> = ({ children }: any) => {
  const [isLoading, setIsLoading] = useState<boolean>();

  const [alertState, setAlertState] = useState<{ message: React.ReactNode, resolve: (value: unknown) => void } | null>();
  const [confirmState, setConfirmState] = useState<{ message: React.ReactNode, resolve: (value: unknown) => void, reject: (reason?: any) => void } | null>();

  const [toastState, setToastState] = useState<{ message: React.ReactNode, variant?: Variant, resolve: (value: unknown) => void } | null>();

  const showLoader = () => {
    setIsLoading(true);
  };

  const hideLoader = () => {
    setIsLoading(false);
  }

  const confirm = useCallback((message: any) => {
    return new Promise((resolve, reject) => {
      setConfirmState({ message, resolve, reject });
    });
  }, []);

  const handleConfirm = () => {
    if (confirmState) {
      confirmState.resolve(true);
      setConfirmState(null);
    }
  };

  const handleCancel = () => {
    if (confirmState) {
      confirmState.resolve(false);
      setConfirmState(null);
    }
  };

  const handleAlert = () => {
    if (alertState) {
      alertState.resolve(null);
      setAlertState(null);
    }
  };

  const handleToast = () => {
    if (toastState) {
      toastState.resolve(null);
      setToastState(null);
    }
  };

  const alert = useCallback((message: React.ReactNode) => {
    return new Promise((resolve) => {
      setAlertState({ message, resolve });
    });
  }, []);

  const toast = useCallback((message: React.ReactNode, variant?: Variant) => {
    return new Promise((resolve) => {
      setToastState({ message, variant, resolve });
    });
  }, []);

  return <UtilityContext.Provider value={{
    alert, confirm, toast, isLoading, showLoader, hideLoader
  }}>
    {isLoading && <Loader />}
    <ToastContainer position="bottom-center">
      <Toast show={!!toastState} onClose={handleToast} delay={3000} role="alert" autohide aria-live="assertive" aria-atomic={true} className={`text-bg-${toastState?.variant ?? 'info'} border-0`}>
        <Toast.Body>{toastState?.message}</Toast.Body>
      </Toast>
    </ToastContainer>
    <Alert handleClose={handleAlert} show={!!alertState}>
      {alertState?.message}
    </Alert>
    <Confirm handleCancel={handleCancel} handleProceed={handleConfirm} show={!!confirmState}>
      {confirmState?.message}
    </Confirm>
    {children}
  </UtilityContext.Provider>
};
export const useUtility = () => useContext(UtilityContext);